/* Galaxy - infinite scroll for paginated product lists (collection + search).

   TRAPS - read before editing:

   1. Loaded WITHOUT defer so it sets window.__gxInfinite before the legacy inline
      copy in sections/main-collection-product-grid.liquid runs. That old copy read
      .pagination__item--next, but Dawn puts --next on the PREVIOUS link, so from
      page 2 it refetched page 1 forever. This version reads the ?page= number off
      every pagination link and only advances to a higher, unseen page.

   2. (2026-08-03) Used to be collection-only because the snippet was rendered from
      main-collection-banner.liquid. Now loaded globally from
      snippets/galaxy-header-motion.liquid so /search gets it too.

   3. (2026-08-03) #product-grid is NOT the same element on the two templates:
        collection : <ul id=product-grid class='grid product-grid'>   <- IS the grid
        search     : <div id=product-grid class='template-search__results'>
                       <ul class='grid product-grid'>                 <- grid is INSIDE
      getElementById('product-grid') therefore appended <li> into a <div> on search
      and nothing rendered. grid() now resolves ul.product-grid first, id as fallback.
      Same trap already bit assets/galaxy-card-media.css - see its header.

   4. Dawn does NOT put a template class on <body> (it is just 'gradient animate--...'),
      so template detection has to go through location.pathname. */
(function () {
  if (window.__gxInfinite2) return; window.__gxInfinite2 = true;
  window.__gxInfinite = true; /* disarm any legacy inline copy */
  var loading = false, loaderEl = null, endEl = null, done = false, seen = {}, MAXPAGES = 60, loaded = 0;
  function container(){ return document.getElementById('ProductGridContainer'); }
  function gridIn(root){
    if (!root) return null;
    var ul = root.querySelector('#ProductGridContainer ul.product-grid') || root.querySelector('ul.product-grid');
    if (ul) return ul;
    var byId = root.getElementById ? root.getElementById('product-grid') : root.querySelector('#product-grid');
    return (byId && byId.tagName === 'UL') ? byId : null;
  }
  function grid(){ return gridIn(document); }
  function pageOf(href){
    try { var u = new URL(href, location.href); var p = parseInt(u.searchParams.get('page'), 10); return isNaN(p) ? null : p; }
    catch (e) { return null; }
  }
  function currentPage(){
    var c = container(); if (!c) return 1;
    var w = c.querySelector('.pagination-wrapper');
    var d = w && parseInt(w.getAttribute('data-gx-page'), 10);
    if (d && !isNaN(d)) return d;
    return pageOf(location.href) || 1;
  }
  function nextUrl(){
    var c = container(); if (!c) return null;
    var cur = currentPage(), best = null, bestPage = Infinity;
    var links = c.querySelectorAll('.pagination-wrapper a[href]');
    for (var i = 0; i < links.length; i++) {
      var h = links[i].getAttribute('href');
      var p = pageOf(h);
      if (p !== null && p > cur && p < bestPage && !seen[p]) { bestPage = p; best = h; }
    }
    return best;
  }
  function hidePag(){ var c = container(); if (!c) return; var w = c.querySelector('.pagination-wrapper'); if (w) w.style.display = 'none'; }
  function injectStyle(){
    if (document.getElementById('gx-loader-style')) return;
    var s = document.createElement('style'); s.id = 'gx-loader-style';
    s.textContent = '.gx-loader{display:none;justify-content:center;align-items:center;gap:.6rem;width:100%;padding:2.4rem 0 1rem;color:#1b2a78;font-weight:600;font-size:.95rem;letter-spacing:.02em;}'
      + '.gx-loader.is-on{display:flex;}'
      + '.gx-spin{width:22px;height:22px;border:3px solid rgba(27,42,120,.22);border-top-color:#1b2a78;border-radius:50%;animation:gxspin .7s linear infinite;}'
      + '@keyframes gxspin{to{transform:rotate(360deg);}}'
      + '.gx-end{width:100%;text-align:center;padding:2.6rem 0 1.4rem;color:#6b7280;font-size:.9rem;letter-spacing:.03em;}'
      + '.gx-end:before{content:"";display:block;width:56px;height:1px;background:rgba(0,0,0,.14);margin:0 auto 1.1rem;}';
    document.head.appendChild(s);
  }
  function ensureLoader(){
    if (loaderEl && document.body.contains(loaderEl)) return loaderEl;
    var c = container(); if (!c) return null;
    loaderEl = document.createElement('div');
    loaderEl.className = 'gx-loader';
    loaderEl.setAttribute('aria-live', 'polite');
    loaderEl.innerHTML = '<span class="gx-spin" aria-hidden="true"></span><span>Loading more…</span>';
    c.appendChild(loaderEl);
    return loaderEl;
  }
  function showLoader(on){ var el = ensureLoader(); if (el) el.classList.toggle('is-on', !!on); }
  function endText(){
    return location.pathname.indexOf('/search') === 0
      ? 'You have reached the end of the results'
      : 'You have reached the end of this collection';
  }
  function showEnd(){
    if (done) return; done = true;
    showLoader(false);
    var c = container(); if (!c) return;
    if (endEl && document.body.contains(endEl)) return;
    endEl = document.createElement('div');
    endEl.className = 'gx-end';
    endEl.textContent = endText();
    c.appendChild(endEl);
  }
  function nearBottom(){
    return (document.documentElement.scrollHeight - (window.scrollY || window.pageYOffset) - window.innerHeight) < 1000;
  }
  function loadNext(){
    if (loading || done) return;
    if (loaded >= MAXPAGES) { showEnd(); return; }
    var url = nextUrl();
    if (!url) { showEnd(); return; }
    var p = pageOf(url);
    if (p === null || seen[p]) { showEnd(); return; }
    seen[p] = 1;
    var abs; try { abs = new URL(url, location.href); } catch (e) { showEnd(); return; }
    loading = true; showLoader(true);
    fetch(abs.href, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var ng = gridIn(doc), g = grid();
      var added = 0;
      if (ng && g) {
        Array.prototype.slice.call(ng.children).forEach(function (li) { g.appendChild(document.importNode(li, true)); added++; });
      }
      var c = container();
      var oldW = c && c.querySelector('.pagination-wrapper');
      var newW = doc.querySelector('#ProductGridContainer .pagination-wrapper');
      if (oldW) {
        if (newW) { newW.style.display = 'none'; newW.setAttribute('data-gx-page', String(p)); oldW.parentNode.replaceChild(newW, oldW); }
        else { oldW.parentNode.removeChild(oldW); }
      }
      loading = false; showLoader(false);
      loaded++;
      if (loaderEl && container()) container().appendChild(loaderEl);
      if (added === 0) { showEnd(); return; }
      if (!nextUrl()) { showEnd(); return; }
      if (nearBottom()) loadNext();
    }).catch(function () { loading = false; showLoader(false); });
  }
  function tick(){ if (!loading && !done && nearBottom() && nextUrl()) loadNext(); }
  function boot(){
    if (!container() || !grid()) return;
    injectStyle();
    hidePag();
    ensureLoader();
    var w = container().querySelector('.pagination-wrapper');
    if (w && !w.getAttribute('data-gx-page')) w.setAttribute('data-gx-page', String(pageOf(location.href) || 1));
    if (!nextUrl()) { showEnd(); return; }
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });
    setInterval(tick, 500);
    setTimeout(tick, 500);
    var host = container();
    if (host && !host.__gxObs) {
      host.__gxObs = true;
      new MutationObserver(function () { hidePag(); }).observe(host, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
